import classNames from 'classnames';
import React from 'react';
import { TailwindThemeName } from '../../constants/common';
import { Button } from '../Button';
import bgEmptyStateGridSvg from './../../../assets/empty-states/empty_state_bg_grid.svg';
import {
  EmptyStateIllustrationSvgMap,
  EmptyStateIllustrationType,
} from './models';

type EmptyStateWithIllustrationProps = {
  title: string;
  description?: string | JSX.Element;
  illustration: EmptyStateIllustrationType | JSX.Element;

  primaryButton?: JSX.Element;
  primaryButtonText?: string | JSX.Element;
  primaryButtonDisabled?: boolean;
  primaryButtonLoading?: boolean;
  primaryButtonOnClick?: () => void;
  primaryButtonTheme?: TailwindThemeName;
  primaryButtonCustomThemeHex?: string;

  secondaryButtonText?: string | JSX.Element;
  secondaryButtonDisabled?: boolean;
  secondaryButtonLoading?: boolean;
  secondaryButtonOnClick?: () => void;
  size?: 'small' | 'large' | 'xlarge';
  noBackgroundGrid?: boolean;
  primaryButtonProps?: React.ButtonHTMLAttributes<HTMLButtonElement> & {
    'data-intercom-target'?: string;
  };
  secondaryButtonProps?: React.ButtonHTMLAttributes<HTMLButtonElement> & {
    'data-intercom-target'?: string;
  };
};

export const EmptyStateWithIllustration = ({
  title,
  description,
  illustration,

  primaryButton,
  primaryButtonText,
  primaryButtonOnClick,
  primaryButtonDisabled,
  primaryButtonLoading,
  primaryButtonTheme,
  primaryButtonCustomThemeHex,

  secondaryButtonText,
  secondaryButtonDisabled,
  secondaryButtonLoading,
  secondaryButtonOnClick,
  size = 'large',
  noBackgroundGrid = false,
  primaryButtonProps = {},
  secondaryButtonProps = {},
}: EmptyStateWithIllustrationProps) => {
  return (
    <React.Fragment>
      <div
        className="m-auto flex min-h-[440px] w-full max-w-[658px] flex-col items-center justify-center rounded-2xl p-8"
        style={{
          ...(!noBackgroundGrid && {
            background: `url(${bgEmptyStateGridSvg}) no-repeat center center`,
          }),
        }}
      >
        {typeof illustration === 'string' ? (
          <div
            className={classNames({
              'h-56 w-72': size === 'xlarge',
              'h-48 w-60': size === 'large',
              '!h-16 !w-16': size === 'small',
            })}
            style={{
              background: `url(${EmptyStateIllustrationSvgMap[illustration]}) no-repeat center center`,
            }}
          ></div>
        ) : (
          illustration
        )}
        <span
          className={classNames('mt-4 font-medium text-slate-900', {
            'text-xl': size === 'large',
            'text-sm': size === 'small',
          })}
        >
          {title}
        </span>
        {description && (
          <span className="mt-2 text-center text-sm font-normal text-slate-500">
            {description}
          </span>
        )}
        <div className="mt-6 flex items-center gap-x-3">
          {primaryButton ? (
            primaryButton
          ) : primaryButtonText ? (
            <Button
              type="button"
              variant={primaryButtonTheme}
              customThemeHex={primaryButtonCustomThemeHex}
              onClick={primaryButtonOnClick}
              disabled={primaryButtonDisabled}
              isLoading={primaryButtonLoading}
              {...primaryButtonProps}
            >
              {primaryButtonText}
            </Button>
          ) : null}
          {secondaryButtonText && (
            <Button
              type="button"
              variant="clear"
              onClick={secondaryButtonOnClick}
              disabled={secondaryButtonDisabled}
              isLoading={secondaryButtonLoading}
              {...secondaryButtonProps}
            >
              {secondaryButtonText}
            </Button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
